import React from 'react';
import { Navbar } from '@/components/landing/Navbar';
import { HeroSection } from '@/components/landing/HeroSection';
import { LogoBar } from '@/components/landing/LogoBar';
import { HowItWorks } from '@/components/landing/HowItWorks';
import { Benefits } from '@/components/landing/Benefits';
import { Features } from '@/components/landing/Features';
import { StatsBar } from '@/components/landing/StatsBar';
import { Pricing } from '@/components/landing/Pricing';
import { WhyAgentick } from '@/components/landing/WhyAgentick';
import { Testimonials } from '@/components/landing/Testimonials';
import { CTASection } from '@/components/landing/CTASection';
import { Footer } from '@/components/landing/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <LogoBar />
      <HowItWorks />
      <StatsBar />
      <Benefits />
      <Features />
      <WhyAgentick />
      <Pricing />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
}
